import { useImperativeHandle } from 'react'
import { ActionCardData, updateActionCard, UpdaterDto } from '@playbooks/action-cards-utils/src'

import { useAppContext } from '../contexts/AppContext'
import { Slide, SlidesData } from '../types'

export interface ActionCardsElement {
  getValue: () => ActionCardData | null
  getSlides: () => SlidesData
  highlightElementIds: (ids: number[]) => void
  partialUpdate: (data: UpdaterDto) => ActionCardData
}

export default function useActionCardsApiRegister(
  ref: React.Ref<ActionCardsElement | null> | undefined,
  slides: Record<number, Slide>,
) {
  const { rootRef, data, setActionCards, prevActionCardsDataRef, setHighlightedIds } = useAppContext()

  useImperativeHandle(ref, (): ActionCardsElement => {
    return {
      getValue: () => data ?? null,
      getSlides: () => {
        return slides
      },
      highlightElementIds: (ids: number[]) => {
        setHighlightedIds(ids)
      },
      partialUpdate: partOfData => {
        const updatedData = JSON.parse(JSON.stringify(updateActionCard(data, partOfData))) as ActionCardData

        prevActionCardsDataRef.current = updatedData

        setActionCards(updatedData)

        return updatedData
      },
    }
  }, [ref, data, rootRef, setActionCards, setHighlightedIds])
}
